export default __webpack_public_path__ + "static/media/indiana_jones.e3e05c2d.png";